<div class="stickybutton">
    <a href="javascript:window.print()">
        <i [ngClass]="iconClass"></i>
        </a>
</div>